"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _chunkB2edacfb = require("./chunk-b2edacfb.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _chunk48de = require("./chunk-48de8464.js");

var _constants = require("./constants.js");

require("./chunk-e8276423.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = (0, _chunkB2edacfb.a)(["\n  max-width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var IMAGE_HOST = "https://undraw.oswaldlabs.com";
var ILLUSTRATION_SOURCES = {
  UNDRAW: "undraw"
};

var IllustrationType = _propTypes.default.oneOf(_constants.ILLUSTRATION_TYPES);

var IllustrationSourceType = _propTypes.default.oneOf(Object.values(ILLUSTRATION_SOURCES));

var CIllustration = function CIllustration(_ref) {
  var type = _ref.type,
      color = _ref.color,
      source = _ref.source,
      imgProps = (0, _chunkB2edacfb.j)(_ref, ["type", "color", "source"]);

  switch (source) {
    case ILLUSTRATION_SOURCES.UNDRAW:
    default:
      return _react.default.createElement(StyledIllustration, (0, _chunkB2edacfb.g)({
        src: "".concat(IMAGE_HOST, "/").concat(getColorString(color), "/").concat(type, ".svg")
      }, imgProps));
  }
};

var getColorString = function getColorString(color) {
  if (color.includes("$")) {
    return getColorString(_chunk48de.a[color]);
  }

  return color.replace("#", "");
};

var StyledIllustration = _styledComponents.default.img.withConfig({
  displayName: "CIllustration__StyledIllustration",
  componentId: "sc-1w01npc-0"
})(_templateObject());

CIllustration.displayName = "CIllustration";
CIllustration.propTypes = {
  type: IllustrationType.isRequired,
  color: _propTypes.default.string,
  alt: _propTypes.default.string,
  source: IllustrationSourceType
};
CIllustration.defaultProps = {
  color: "$purple",
  alt: "Illustration",
  source: ILLUSTRATION_SOURCES.UNDRAW
};
CIllustration.enums = {
  IllustrationSourceType: ILLUSTRATION_SOURCES,
  IllustrationType: _constants.ILLUSTRATION_TYPES.reduce(function (sum, curr) {
    return (0, _chunkB2edacfb.i)({}, sum, (0, _chunkB2edacfb.h)({}, curr, curr));
  }, {})
};
CIllustration.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CIllustration",
  "props": {
    "color": {
      "defaultValue": {
        "value": "\"$purple\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "alt": {
      "defaultValue": {
        "value": "\"Illustration\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "source": {
      "defaultValue": {
        "value": "\"undraw\"",
        "computed": false
      },
      "type": {
        "name": "custom",
        "raw": "IllustrationSourceType"
      },
      "required": false,
      "description": ""
    },
    "type": {
      "type": {
        "name": "custom",
        "raw": "IllustrationType.isRequired"
      },
      "required": false,
      "description": ""
    }
  }
};
var _default = CIllustration;
exports.default = _default;
CIllustration.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CIllustration",
  "props": {
    "color": {
      "defaultValue": {
        "value": "\"$purple\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "alt": {
      "defaultValue": {
        "value": "\"Illustration\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "source": {
      "defaultValue": {
        "value": "\"undraw\"",
        "computed": false
      },
      "type": {
        "name": "custom",
        "raw": "IllustrationSourceType"
      },
      "required": false,
      "description": ""
    },
    "type": {
      "type": {
        "name": "custom",
        "raw": "IllustrationType.isRequired"
      },
      "required": false,
      "description": ""
    }
  }
};